import DomainAction, { DomainActionProperties } from './DomainAction';
import { DescriptionWrapperProperties } from './common/DescriptionWrapper';
import { Domain } from 'fs-api-client';
import { updateDomain } from '../services/filespace';
import { injectDomain } from './hocs/DomainInjector';
import { RETURN_ROUTE_PARAMETER_NAME } from '../utils/constants';
import { PageRoutes } from './root/Routes';

class RenameDomain extends DomainAction {
    constructor(props: DomainActionProperties) {
        super(props);
    }

    protected getDescriptions(): DescriptionWrapperProperties {
        const returnPageName = this.props.computedMatch.params[RETURN_ROUTE_PARAMETER_NAME]; 
        return {
            title: 'Rename domain',
            description: 'You can rename your domain. The domain uniquely identifies your organization and groups together all of your Filespaces. Each Filespace provides a global shared namespace accessible to multiple users or devices and can be stored in a different provider and region.',
            previousPageTitle: returnPageName,
            onPreviousPageLinkClick: () => {
                this.props.history.push('/' + returnPageName);
            }
        };
    }

    protected onDomainLoaded(domain: Domain) {
        if (this.props.filespaces.length > 0) {
            this.setState({ errorMessage: 'All filespaces have to be deleted before you can rename your domain.', isError: true, workspaceName: domain.name });
        } else {
            this.setState({ isError: false, workspaceName: domain.name });
        }
    }

    protected onDomainSubmit(workspaceName: string) {
        if (this.props.domain) {
            let shallowCopy = { ...this.props.domain };
            shallowCopy.name = workspaceName;
            updateDomain(this.props.domain.id!, shallowCopy)
                .then(() => {
                    this.props.history.push(PageRoutes.Dashboard);
                })
                .catch((error: any) => {
                    let message = error.response.body.message;
                    if (error.response.body.code === 500) {
                        message = 'Something went wrong.';
                    }
                    this.setState({
                        errorMessage: message,
                        isAwaitingRequest: false
                    });
                });
        }
    }
}

export default injectDomain(RenameDomain);



// WEBPACK FOOTER //
// ./src/webportal/components/RenameDomain.tsx